/* eslint-disable no-console */
import styled from 'styled-components';

const BoxContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 126px;
  height: 64.18px;
  border-radius: 2px;
  background: rgba(60, 113, 221, 0.1);
  padding: 1px;


  .box-title {
    color: #000;
    text-align: center;
    font-family: Roboto;
    font-size: 10px;
    font-weight: 400;
    margin-bottom: ${(props) => {
      if (props.text.length < 42) {
        return '4px';
      } else {
        return '8px';
      }
    }};
    line-height: 1.2;

    span {
      display: block;
      word-wrap: break-word;
    }
  }

  .box-content {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const Box = ({
  dataBox = {
    width: '',
    title: '',
    content: '',
  },
}) => {
  return (
    <BoxContainer width={dataBox.width} text={dataBox.title}>
      <div className="box-title">
        <span>{dataBox.title}</span>
      </div>
      <div className="box-content">{dataBox.content}</div>
    </BoxContainer>
  );
};
